/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
// import { each, get } from 'lodash';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';

// const QuillNoSSRWrapper = dynamic(() => import('react-quill'), { ssr: false, loading: () => <p>Loading ...</p> })

const Quill = typeof window === 'object' ? require('quill') : () => false;

const Editor = (props) => {
  // value, onChange, readOnly, className 
  const imgInputRef = useRef(null);

  const quillEle = useRef();
  const quillIns = useRef();

  useEffect(() => {
    if (quillIns) {

      const quill = quillIns.current;

      if (props.defaultValue && quill) {
        // console.log(props.defaultValue)
        // const delta = quill.clipboard.convert(props.defaultValue);
        // const delta = 
        quill.clipboard.dangerouslyPasteHTML(props.defaultValue, 'user');
        // console.log(delta)
        // quill.setContents(delta, 'silent');
        // quill.root.innerHTML = props.defaultValue
      }
    }
  }, [props.defaultValue])

  useEffect(() => {
    quillIns.current = new Quill(quillEle.current, {
      theme: props.readOnly ? 'bubble' : 'snow',
      placeholder: '내용',
      value: props.defaultValue,
      modules
    });

    const quill = quillIns.current;

    if (props.value) {
      quill.root.innerHTML = props.value
    }

    quill.on('text-change', (delta, oldDelta, source) => {
      if (source === 'user') {
        props.onChange(quill.root.innerHTML)
      }

      if (props.readOnly) {
        quill.enable(false)
      }
    });
  }, [])


  const modules = {
    toolbar: {
      container: [
        [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
        [{ size: [] }],
        [{ 'align': [] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' },
        { 'indent': '-1' }, { 'indent': '+1' }],
        // ['link', 'image', 'video'],
        ['clean']
      ],
      handlers: {
        image: () => {
          let fileInput = document.getElementById('uploadImageFile-quill')
          fileInput.setAttribute('multiple', 'multiple')
          fileInput.addEventListener('change', () => { })

          imgInputRef.current.click()
        },
      },
    },
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false
    }
  }

  const onFileChange = async () => {
    if (!window.FileReader) {
      alert('해당 브라우저는 window.FileReader를 지원하지 않습니다.');
      console.error('해당 브라우저는 window.FileReader를 지원하지 않습니다.');
    }
    // const files = imgInputRef.current.files;
    try {
      // 이미지 등록 액션
    } catch (e) {
      console.log('이미지 등록 실패 error: ', e);
    }
    imgInputRef.current.value = '';
  }

  return (
    <div className='contract-document'>
      <div
        ref={quillEle}
        style={props.style} // height를 조정하면서, 하단 버튼과 겹치는 부분이 생겨서 marginBottom을 추가함.
      ></div>
      <input
        ref={imgInputRef}
        style={
          {
            width: 0,
            height: 0,
            opacity: 0
          }
        }
        type="file"
        onChange={onFileChange}
        accept="image/*"
        id="uploadImageFile-quill"
      />
    </div>
  )
}

export default Editor